const CONVERSATIONS_STATISTICS = {
  CONVS_STATS_HEADER_TITLE: 'مکالمات',
  PLATFORMS_STATS_HEADER_TITLE: 'پلتفرم',
  CONVS_STATS_HEADER_DESCRIPTION:
    'با انتخاب بازه زمانی دلخواه، می‌توانید آمار مکالمات (مانند مکالمات پایان یافته یا قبول شده) را ببینید.',
  PLATFORMS_STATS_HEADER_DESCRIPTION:
    'در اینجا می توانید آمار همه پلتفرم ها را مشاهده کنید.',
  CONVS_STATS_OVERALL_STATISTICS_TITLE: 'تعداد کل مکالمات',
  CONVS_STATS_CHART_SECTION_TITLE: 'آمار مكالمات',
  CONVS_REPORT_BADGE_all_CONVS_TITLE: 'مکالمات',
  CONVS_REPORT_BADGE_all_CONVS_DESC: 'مکالمه در هفته گذشته',
  CONVS_REPORT_BADGE_ENDED_TITLE: 'مکالمات پایان یافته',
  CONVS_REPORT_BADGE_STARTED_TITLE: 'مکالمه شروع شده از طرف اپراتور',
  USERS_STATS_HEADER_TITLE: 'کاربران',
  USERS_STATS_HEADER_DESCRIPTION:
    'در اینجا می توانید آمار همه کاربران را مشاهده کنید.',

  //chart
  CONVS_CHART_LEGEND_ACCEPTED: 'مکالمات قبول شده',
  CONVS_CHART_LEGEND_ENDED: 'مکالمات پایان یافته',
  CONVS_CHART_LEGEND_CLOSED_AGENT: 'مکالمات بدون پاسخ',
  CONVS_CHART_LEGEND_DENIED_CONVERSATION: 'مکالمات رد شده',
  CONVS_CHART_LEGEND_NO_DATA: 'هیچ اماری موجود نیست',
  AREA_CHART_DEFAULT_OOUNT_LABEL: 'تعداد',

  CONVS_CHART_CHOOSING_TIME_PERIOD_LABEL: 'انتخاب بازه زمانی',

  // Messages stats section
  MESSAGES_HEADING_TITLE: 'پیام ها',
  MESSAGES_HEADING_DESCRIPTION:
    'این قسمت مربوط به آمار پیام‌هایی است که در داخل مکالمات ارسال شده‌اند ، باتوجه به اینکه احتمال دارد پردازش داده ی مربوط به پیام ها زمان بر باشد شما میتوانید درخواست خود را در صورتی که قبلا ثبت نکردید ارسال کنید تا زمانی که آمار درخواستی آماده شد آن را مشاهده کنید .',
  ALL_MESSAGES_CARD_TITLE: 'تعداد کل پیام های رد و بدل شده',
  TEXT_MESSAGES_CARD_TITLE: 'تعداد کل پیام‌های متنی',
  IMAGE_MESSAGES_CARD_TITLE: 'تعداد کل پیام‌های از نوع عکس',
  VIDEO_MESSAGES_CARD_TITLE: 'تعداد کل پیام‌های ویدیویی',
  VOICE_MESSAGES_CARD_TITLE: 'تعداد کل پیام‌های صوتی',
  FILE_MESSAGES_CARD_TITLE: 'تعداد کل پیام‌های از نوع فایل',
  MESSAGE_CARD_COUNT_TITLE: 'تعداد',
  MESSAGE_CARD_PERCENT_RATE_TITLE: 'نرخ رشد',
  MESSAGES_CHART_HORIZONTAL_LABEL: 'تعداد',

  TOTAL_PLATFORMS: 'تعداد کاربران',
  WEB_USERS: 'کاربران وب',
  MOBILE_USERS: 'کاربران موبایل',
  MONTH: 'ماه',
  DAY: 'روز',
  HOUR: 'ساعت',

  POPULAR_BROWSER: 'مرورگر محبوب',

  PLATFORM_KEYWORD: 'پلتفرم',
  USER_KEYWORD: 'آمار کاربران',

  BROWSER_STATS_TITLE: 'آمار مرورگر',
  OS_STATS_TITLE: 'آمار سیستم عامل',
  USER_UNIT: 'کاربر',
  CHROME: 'گوگل کروم',
  FIREFOX: 'فایرفاکس',
  SAFARI: 'سافاری',
  OPERA: 'اپرا',
  WINDOWS: 'ویندوز',
  LINUX: 'لینوکس',
  MAC: 'مک',
  IOS: 'ای او اس',
  ANDROID: 'اندروید',
  MAX_USERS_DAY_NIGHT: 'بیشترین کاربران در روز',
  MAX_USERS_HOUR: 'بیشترین کاربران در ساعت',

  // excel export modal
  EXCEL_EXPORT_MODAL_HEADER_TITLE: 'دریافت خروجی اکسل',
  EXCEL_EXPORT_MODAL_DESC:
    'نوع پیام هایی که میخواهید در خروجی اکسل باشد را انتخاب کنید.',
  EXCEL_EXPORT_MODAL_PERIOD_LABEL: 'بازه‌ی زمانی',
  EXCEL_EXPORT_MODAL_WEBSITE_LABEL: 'وبسایت',
  EXCEL_EXPORT_MODAL_TEXT_MSG: 'پیام‌های متنی',
  EXCEL_EXPORT_MODAL_IMG_MSG: 'پیام از نوع عکس',
  EXCEL_EXPORT_MODAL_VIDEO_MSG: 'پیام ویدیویی',
  EXCEL_EXPORT_MODAL_AUDIO_MSG: 'پیام صوتی',
  EXCEL_EXPORT_MODAL_FILE_MSG: 'پیام از نوع فایل',
  EXCEL_EXPORT_MODAL_FOOTER_CANCEL: 'انصراف',
  EXCEL_EXPORT_MODAL_FOOTER_SUBMIT: 'دریافت',
  EXCEL_EXPORT_MODAL_SEND_EMAIL_TOAST:
    'فایل خروجی اکسل به ایمیل شما ارسال خواهد شد',
  EXCEL_EXPORT_MODAL_CHOOSE_WEBSITE_TOAST_WARN:
    'لطفا وبسایت موردنظر خود را انتخاب کنید',
  EXCEL_EXPORT_MODAL_CHOOSE_MESSAGE_TYPE_TOAST_WARN:
    'لطفا حداقل یک نوع پیام را انتخاب کنید',
  EXCEL_EXPORT_MODAL_MAX_LIMIT_WARN:
    'روزانه فقط میتوانید 2 بار خروجی اکسل دریافت کنید',
  EXCEL_EXPORT_PROBLEM_SUBMITING_MSG:
    'مشکلی در ثبت درخواست شما ایجاد شده است ! لطفا دوباره تلاش کنید .',
  EXCEL_EXPORT_NO_REQUEST_SUBMITED_MSG:
    'برای بازه ی زمانی انتخاب شده درخواستی ثبت نشده است !',
  EXCEL_EXPORT_WHAIT_FOR_PROCESS_MSG:
    'لطفا منتظر بمانید ! درخواست شما در حال پردازش است !',
  EXCEL_EXPORT_NO_REQEST_CHOOSE_PERIOD_P_1: 'آیا مایلید برای بازه ی',
  EXCEL_EXPORT_NO_REQEST_CHOOSE_PERIOD_P_2: 'تا ',
  EXCEL_EXPORT_NO_REQEST_CHOOSE_PERIOD_P_3: 'درخواست خود را ثبت کنید ؟',
  SEND_REQUEST: 'ارسال درخواست',
};

export default CONVERSATIONS_STATISTICS;
